import React from 'react'

const ReactionContext = React.createContext(null)

export default ReactionContext